import { PopupControl } from './models/popup-control.model';
import { NotificationService } from 'src/app/services/notification.service';
import { CoreSetting } from 'src/app/pages/settings/settings.service';
import { Injectable } from '@angular/core';
import {  NavigationStart, Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class SettingsPopUpService {

	public popupControl: PopupControl = new PopupControl(
		{
			width: '80%',
			height: '80%',
		}
	);

	public dataSource: any[] = [];

	private _settingsMap: Map<string, CoreSetting[]> = new Map<string, CoreSetting[]>();

	public addSettings(preventExpansionOfGroup: boolean, ...coreSettings: CoreSetting[]): void {

		

		for (let a = 0; a < coreSettings.length; a++) {
			const coreSetting = coreSettings[a];

			if (this._settingsMap.has(coreSetting.sourceGroupName)) {
				if (preventExpansionOfGroup) {
					continue;
				}

				const sourceGroupCoreSettings = this._settingsMap.get(coreSetting.sourceGroupName);

				if (sourceGroupCoreSettings.find((item) => item.settingId === coreSetting.settingId)) {
					continue;
				}

				sourceGroupCoreSettings.push(coreSetting);
			} else {
				this._settingsMap.set(coreSetting.sourceGroupName, [coreSetting]);
			}

			coreSetting.initializeSelectionItems();

			this.dataSource.push(coreSetting);
		}
	}

	public reset(): void {
		this.popupControl.options.title = null;
		this.popupControl.description = null;

		this.dataSource = [];

		this._settingsMap = new Map<string, CoreSetting[]>();

		
	}

	constructor(
		private _router: Router,
		private _notificationService: NotificationService,
	) {
		this._router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationStart) {
					this.reset();
				}
			}
		);
	}
}
